import { useCallback } from 'react';

import { addParamsToUrl } from 'utils/query';

import { useNavigate } from './useNavigation';

export interface Options {
  query?: Record<string, string>;
}

export type QueryNavigateFunction = (
  url: string | number,
  options?: Options
) => void;

export const useQueryNavigate = () => {
  const navigate = useNavigate();

  const navigateParams: QueryNavigateFunction = useCallback(
    (url, options) => {
      if (typeof url === 'number') {
        navigate(url);
      } else {
        const { query } = options ?? {};
        const oldSearch = window.location.search;
        const params = new URLSearchParams(oldSearch).entries();
        const newUrl = addParamsToUrl(url, {
          ...Object.fromEntries(params),
          ...query,
        });
        navigate(newUrl);
      }
    },
    [navigate]
  );

  return navigateParams;
};
